import { useEffect } from "react";

/**
 * 修改背景色
 */
const useBgByClass = (className = "", container?: HTMLElement) => {
  useEffect(() => {
    const classNameArr = className.trim()
      ? className.trim().split(/[ ]+/g)
      : [];
    if (!classNameArr.length || typeof document === "undefined") {
      return () => false;
    }
    const domContainer = container || document.body;
    if (!domContainer) {
      return () => false;
    }
    const containerClassList = domContainer.classList;
    containerClassList.add(...classNameArr);
    return () => containerClassList.remove(...classNameArr);
  }, [className, container]);
};

export default useBgByClass;
